export const INFO_TITLE = 'Surgiu uma nova ideia para você.';

export const SHARE_REQUEST = ' solicitou compartilhamento';

export const SHARE_ALLOW = ' compartilhou com você';

export const SHARE_BUTTON_DENY = 'Bloquear';

export const SHARE_BUTTON_ACCEPT = 'Aceitar';

export const INFO_BUTTON = 'Saiba Mais';

export const INVITE = 'gostaria de adicionar você como contato.';

export const INVITE_ACCEPT = 'aceitou seu convite de contato.';

const defaultObj = {
    INFO_TITLE,
    SHARE_REQUEST,
    SHARE_ALLOW,
    SHARE_BUTTON_ACCEPT,
    SHARE_BUTTON_DENY,
    INFO_BUTTON,
    INVITE,
    INVITE_ACCEPT
};

export default defaultObj;
